import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m2.613 1.21.094.083 20 20a1 1 0 0 1-1.32 1.497l-.094-.083-4.154-4.154C15.694 19.4 13.971 20 12 20c-3.016 0-5.444-1.404-7.199-2.943-1.754-1.538-2.906-3.271-3.4-4.09a1.865 1.865 0 0 1 0-1.932c.5-.831 1.696-2.632 3.528-4.203l.266-.222-3.902-3.903a1 1 0 0 1 1.32-1.497zm4.005 6.822C4.856 9.423 3.667 11.16 3.154 12c.459.752 1.472 2.243 2.966 3.553C7.66 16.903 9.636 18 12 18c1.353 0 2.577-.359 3.667-.919l-1.56-1.559A4.002 4.002 0 0 1 8.6 10.014zM12 4c3.016 0 5.444 1.404 7.199 2.943 1.754 1.538 2.906 3.271 3.4 4.09.36.597.36 1.337 0 1.933-.32.53-.906 1.428-1.744 2.408a1 1 0 1 1-1.52-1.301A16.37 16.37 0 0 0 20.847 12c-.459-.752-1.472-2.243-2.966-3.553C16.34 7.097 14.364 6 12 6a7.62 7.62 0 0 0-1.262.105 1 1 0 1 1-.333-1.972A9.587 9.587 0 0 1 12 4zm-1.905 7.51a2 2 0 0 0 2.517 2.516z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }